import type { ReactNode } from "react";

import { cn } from "#/lib/utils";

export function PageIntro({
  children,
  className,
  align = "center",
}: {
  children: ReactNode;
  className?: string;
  align?: "center" | "start";
}) {
  return (
    <div
      className={cn(
        "flex max-w-2xl flex-col gap-2",
        align === "center" ? "mx-auto items-center text-center" : "items-start text-left",
        className,
      )}
    >
      {children}
    </div>
  );
}
